import { ApolloClient, InMemoryCache } from '@apollo/client';
import { BatchHttpLink } from '@apollo/client/link/batch-http';
import React, { createContext } from 'react';
import { useLandsbankinnApollo } from '../hooks/useLandsbankinnApollo';
import type { GetApolloClientProps } from '../lib/landsbankinnApi';

export interface ILandsbankinnContext {
  client: ApolloClient<any>;
}

export const LandsbankinnContext = createContext<ILandsbankinnContext>({
  client: new ApolloClient({
    cache: new InMemoryCache(),
    link: new BatchHttpLink({ uri: '' }),
  }),
});

type ILandsbankinnContextProps = GetApolloClientProps;

export const LandsbankinnContextProvider: React.FC<
  ILandsbankinnContextProps
> = ({ children, ...rest }) => {
  const client = useLandsbankinnApollo(rest);
  return (
    <LandsbankinnContext.Provider value={{ client }}>
      {children}
    </LandsbankinnContext.Provider>
  );
};
